import React from "react";
import { Shield, Lock, MapPin } from "lucide-react";
import { useTenantData } from "@/contexts/TenantModeContext";

export default function Footer() {
  const { tenant } = useTenantData();
  return (
    <footer
      className="h-8 flex items-center justify-between px-6 text-[11px] text-ink-secondary bg-canvas border-t border-border-subtle"
      data-testid="app-footer"
    >
      <span>ALGOS · A product of TRALENEX · v1.0</span>
      <div className="hidden md:flex items-center gap-3">
        <span className="inline-flex items-center gap-1">
          <MapPin size={11} /> {tenant.region}
        </span>
        <span className="text-border-strong">•</span>
        <span className="inline-flex items-center gap-1">
          <Lock size={11} /> AES-256 · TLS 1.3
        </span>
        <span className="text-border-strong">•</span>
        <span className="inline-flex items-center gap-1">
          <Shield size={11} /> Audit chain ✓
        </span>
      </div>
    </footer>
  );
}
